import React from 'react';
import { VideoPlugin } from './VideoPlugin';
import styled from 'styled-components';

import WinVideoMp4 from './videos/dart/win.mp4';
import LoseVideoMp4 from './videos/dart/lose.mp4';
import LandingVideoMp4 from './videos/dart/landing.mp4';

import { IProps } from '../../common-types/Prop';

export const VideoContainer = styled.div`
  margin-top: 20.6vh;
  position: relative;
  display: inline-block;
  width: 60.5vw;
  overflow: hidden;
  height: 64.5vh;
`;
VideoContainer.displayName = 'VideoContainer';

export const DartPlugin: React.FunctionComponent<IProps> = (props) => (
  <VideoPlugin
    {...props}
    winVideo={{ mp4: WinVideoMp4 }}
    loseVideo={{ mp4: LoseVideoMp4 }}
    landingVideo={{ mp4: LandingVideoMp4 }}
    VideoWrapper={VideoContainer}
  />
);